import ImageUploadPreview from './ImageUploadPreview';

export default ImageUploadPreview;
